import script from "./FirstTask.vue?vue&type=script&setup=true&lang=js"
export * from "./FirstTask.vue?vue&type=script&setup=true&lang=js"

import "./FirstTask.vue?vue&type=style&index=0&id=980911d4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-980911d4"]])

export default __exports__